import {billingService} from '@/services/billing/billingService';

export function usePremium() {
    const presentPayWall = async (options?: {
        placement?: string;
        title?: string;
        text?: string;
        callback?: () => void;
    }) => {
        await billingService.presentPaywall(options?.placement || 'premium', {
            title: options?.title,
            text: options?.text,
        });
        if (options?.callback) {
            options.callback();
        }
    };

    return {
        presentPayWall,
    };
}
